import services from '@/config/services'

export default class OfferteService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async getAllItemsForMindTable(opts = {}){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/offerte/listini/search`
    
    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  getAllColumnsForMindTable(){
    return [
      {
        property: 'name',
        label: 'Nome',
        sortable: true,
        default: true,
      },
      {
        property: 'code',
        label: 'Codice',
        // type: {
        //   isBoolean:true
        //   isCurrency:true
        //   isDate: true
        // },
        sortable: true,
        default: true,
      },
      {
        property: 'tipologia',
        label: 'Tipo',
        sortable: true,
        default: true,
      },
      {
        property: 'offerta',
        label: 'Offerta',
        sortable: true,
        default: true,
      },
      {
        property: 'data_inizio',
        label: 'Data Inizio',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'data_fine',
        label: 'Data Fine',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: "f1",
        label: "F1",
        sortable: true,
      },
      {
        property: "f2",
        label: "F2",
        sortable: true,
      },
      {
        property: "f3",
        label: "F3",
        sortable: true,
      },
      {
        property: "p",
        label: "P",
        sortable: true,
      },
      {
        property: "op",
        label: "OP",
        sortable: true,
      },
      {
        property: "m",
        label: "M",
        sortable: true,
      },
      {
        property: "pcv",
        label: "PCV",
        sortable: true,
      },
      {
        property: "pcv_var",
        label: "PCV VAR",
        sortable: true,
      },
      {
        property: "pa",
        label: "PA",
        sortable: true,
      },
      {
        property: "gettone1",
        label: "gettone1",
        sortable: true,
      },
      {
        property: "giorni_gettone1",
        label: "giorni_gettone1",
        sortable: true,
      },
      {
        property: "gettone2",
        label: "gettone2",
        sortable: true,
      },
      {
        property: "giorni_gettone2",
        label: "giorni_gettone2",
        sortable: true,
      },
      {
        property: "gettone3",
        label: "gettone3",
        sortable: true,
      },
      {
        property: "giorni_gettone3",
        label: "giorni_gettone3",
        sortable: true,
      },
      {
        property: "gettone_consumo",
        label: "gettone_consumo",
        sortable: true,
      },
      {
        property: "gettone_ricorrente_punto",
        label: "gettone_ricorrente_punto",
        sortable: true,
      },
      {
        property: "gettone_ricorrente_consumo",
        label: "gettone_ricorrente_consumo",
        sortable: true,
      },

    ]
  }

  async getDettaglioOfferta(id){
    let item = {}

    const url = `${this.baseUrl}/offerte/${id}`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async updateProvvigioniAgente(id, info){
    let item = {}
    let success = false

    const url = `${this.baseUrl}/offerte/${id}/provvigioni-agente`
    try {
      let res = await this.http.put(url, {data: info})
      res = res.data

      item = res.data
      success = res.meta.success
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success
      }
    }
  }

  async updateMassivoOfferte(config){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/offerte`

    try {
      let res = await this.http.put(url, {
        data: config.data,
        filters: config.filters
      })

      res = res.data
      
      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  async getAgentiForOfferta(id){
    let item = {}

    const url = `${this.baseUrl}/agenti-offerta`
    try {
      await this.http.post(url, {id})
      .then(res => {
        item = res.data
      })
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async scaricaXmlOfferta(id) {
    const url = `${services.ask_pratiche_base.url}/api/offerta/scarica-xml`

    try {
      const res = await this.http.post(
        url,
        { offerta: id },
        { responseType: 'blob' }
      )

      const blob = new Blob([res.data], { type: 'application/xml' })
      const downloadUrl = window.URL.createObjectURL(blob)

      const contentDisposition = res.headers['content-disposition']

      let fileName = `offerta_${id}.xml`

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/)

        if (match && match[1]) {
          fileName = match[1]
        }
      }

      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = fileName
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(downloadUrl)
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }
}
